import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { GreenNotify, upload } from "../../helper/helper";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";
import Loader from "../loader/loader";
import "./styles.css";
import { Button, Col, Input, Row, Typography } from "antd";

const AddEmployerCard = () => {
  const dummyImage =
    "https://novathreadbucket.s3.amazonaws.com/nova-app-1685176470232-dummy.PNG";
  const [isloading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [image, setImage] = useState("");

  const navigate = useNavigate();
  const fileInputImageRef = useRef(null);
  const createEmployerCard = () => {
    let getRes = (res) => {
      console.log("res of createEmployerCard", res);
      GreenNotify("Employer card is added successfully");
      navigate("/employerCard");
    };

    let body = {
      name: name,
      image: image,
    };

    console.log("doby", body);

    // callApi(
    //   "POST",
    //   routes.createEmployerCard,
    //   body,
    //   setIsLoading,
    //   getRes,
    //   (error) => {
    //     console.log("error", error);
    //   }
    // );
  };
  const pickImageFile = () => {
    fileInputImageRef.current.click();
  };
  return (
    <div
      style={{
        marginLeft: "5rem",
        marginTop: "2rem",
      }}
    >
      <Loader loading={isloading} />
      <>
        <Row gutter={16}>
          <Col span={9}>
            <Typography.Title
              level={5}
              style={{ marginTop: "2rem", marginLeft: 0 }}
            >
              Employer Card Name
            </Typography.Title>
            <div className="image-upload-container">
              {/* <h1> Add Image</h1> */}
              <img
                onClick={pickImageFile}
                alt="image.jpeg"
                src={image.length !== 0 ? image : dummyImage}
              />
              <input
                type="file"
                ref={fileInputImageRef}
                style={{ display: "none" }}
                onChange={upload((url) => setImage(url), setIsLoading)}
                accept="image/*"
              />
            </div>
          </Col>
        </Row>
      </>
      <Button
        type="primary"
        style={{
          marginTop: "2rem",
          marginBottom: "3rem",
        }}
        onClick={createEmployerCard}
      >
        Add Employer Card
      </Button>
    </div>
  );
};

export default AddEmployerCard;
